import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { SSRFailureProps } from './types.tsx';
import { pushSSRFailureDisplay } from './ssr-failure-display/server-to-client.tsx';
import { getIsTrackingEnabled } from './tracker.tsx';

/**
 * A declarative component that taints a given location as a "fallback"
 * used to detect SSR success rate and the completeness of the page.
 */
export const FallbackIndicator = ({
	reportToSlackChannel,
	fallbackId,
	displayErrorInStaging,
}: SSRFailureProps) => {
	if (__SERVER__) {
		if (!getIsTrackingEnabled()) {
			return null;
		}

		if (displayErrorInStaging && fg('staging-only-show-ssr-error')) {
			pushSSRFailureDisplay({ reportToSlackChannel, fallbackId, displayErrorInStaging });
		}

		if (!fg('jfp-magma-inline-server-files-batch-1')) {
			return (
				// replicate RLL's magic input approach
				<input type="hidden" data-ssr-fallback />
			);
		}
	}
	return null;
};
